import { registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CoreModule } from './@core/core.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { AuthGuard } from './auth-guard';
import { MaintenanceComponent } from './shared/maintenance/maintenance.component';

import localeFr from '@angular/common/locales/fr';
import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { ReportIssuesComponent } from './layout/report-issues/report-issues.component';

registerLocaleData(localeFr, 'fr');

// AoT requires an exported function for factories; Required for i18n Internationalization
const httpLoaderFactory = (httpClient: HttpClient) => new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');

@NgModule({
  declarations: [
    AppComponent,
    ReportIssuesComponent,
    MaintenanceComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,

    ThemeModule.forRoot(),

    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxMaterialTimepickerModule.forRoot(),
    CoreModule.forRoot(),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [
          environment.apiUrl,
          environment.daPresential.url,
          environment.daTranslationsApi.url,
          environment.hrSkillsReferentialV2.url,
          environment.ldap.url,
          environment.masterSport.url,
          environment.mediaUrl,
          environment.myGoogle.url,
          environment.searchApi.url,
        ].filter(Boolean).map(url => url.toLowerCase()),
        sendAccessToken: true,
      },
    }),
  ],
  exports: [
    MaintenanceComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthGuard,
    {provide: LOCALE_ID, useValue: 'fr'},
  ],
})
export class AppModule {
}
